import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BasetaoSpreadsheetGuide from "../pages/seo-article/page";
import SeoArticlePage from "../pages/seo-article/dynamic-article";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/basetao-spreadsheet-guide",
    element: <BasetaoSpreadsheetGuide />,
  },
  {
    path: "/article/:slug",
    element: <SeoArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;